var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 49,
    viewBox: "0 0 88 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 49,
    fill: "#4A5568",
    fillOpacity: 0.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6353 25.4175C40.9156 25.4175 46.0069 22.6922 46.0069 19.3303C46.0069 15.9685 40.9156 13.2432 34.6353 13.2432C28.3549 13.2432 23.2637 15.9685 23.2637 19.3303C23.2637 22.6922 28.3549 25.4175 34.6353 25.4175Z",
    fill: "#4A5568"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6351 29.4758C47.1958 29.4758 57.3783 34.9265 57.3783 41.6502H11.8918C11.8918 34.9265 22.0743 29.4758 34.6351 29.4758Z",
    fill: "#4A5568"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9595 21.3594C64.9595 20.2388 63.2625 19.3303 61.169 19.3303C59.0755 19.3303 57.3784 20.2388 57.3784 21.3594V23.3884H53.5879C51.4944 23.3884 49.7974 24.2969 49.7974 25.4175C49.7974 26.5381 51.4944 27.4466 53.5879 27.4466H57.3784V29.4756C57.3784 30.5963 59.0755 31.5047 61.169 31.5047C63.2625 31.5047 64.9595 30.5963 64.9595 29.4756V27.4466H68.75C70.8436 27.4466 72.5406 26.5381 72.5406 25.4175C72.5406 24.2969 70.8436 23.3884 68.75 23.3884H64.9595V21.3594Z",
    fill: "#4A5568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.296537268079e340eba117a7e4f82e84.svg";
export { ForwardRef as ReactComponent };